import { useContext } from 'react';

import { ConfigContext } from '../context/ConfigProvider';

import type { Type as ConfigType } from '@eventespresso/config';

type Config = ConfigType.Config;

export const useConfig = (): Config => useContext<Config>(ConfigContext);
